// extracted by mini-css-extract-plugin
module.exports = {"section--edit--single":"section--edit--single__1wEpP","section--edit--multiple":"section--edit--multiple__1TwG4"};